import type { StateParamsDeclaration } from "app/pages/sales-intelligence/types/routing";
import { lenientJsonParamType } from "app/pages/sales-intelligence/utils/lenientJsonParamType";

import type { FiltersRoutingParams, SearchResultsRoutingParams } from "../types";

export const searchResultsParams: StateParamsDeclaration<SearchResultsRoutingParams> = {
    isNewOnly: { dynamic: true },
    signalId: { dynamic: true },
};

export const filtersRoutingParams: StateParamsDeclaration<FiltersRoutingParams> = {
    filtersCategory: { type: "string", value: null, dynamic: true },
    filtersGroup: { type: "string", value: null, dynamic: true },
    // Not the built-in `json` type: this one is in the URL, so it gets hand-edited and truncated, and
    // `JSON.parse` throwing during URL matching would fail the transition instead of the one filter.
    filtersPayload: { type: lenientJsonParamType, dynamic: true },
};
